






















import { Component, Vue } from "vue-property-decorator";
import { Image, Lazyload } from 'vant';
import { getQueryParam } from "@/utils/index";

Vue.use(Image);
Vue.use(Lazyload);

@Component({})
export default class ForumList extends Vue {
    cityId: number = 0;

    dataList: any = [
        {
            id: 1,
            title: "异地购房使用深圳公积金",
            desc: "为推进住房公积金异地贷款业务，支持缴存职工异地购房需求，2014年10月9日，住建部、财政部、央行三部委联合下发《关于发展住房公积金个人住房贷款业务的通知》，要求各地放松公积金贷款条件，今后职工连续缴存6个月即可申请公积金贷款",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/77777.jpg",
            url: "http://gjj.sz.gov.cn/topics/ydgf/?from=singlemessage&isappinstalled=0"
        },
        {
            id: 2,
            title: "公积金租房提取",
            desc: "深圳缴存职工提取住房公积金用于支付房租的，职工本人及其家庭成员应当在本市范围内无商品住房、政策性住房和保障性住房，每月可提取额不超过申请当月应缴存额的65%，当年未提取的，可以在以后年度累计提取。",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/333333333.jpg",
            url: "http://gjj.sz.gov.cn/zdyw/zfzzf/"
        },
        {
            id: 3,
            title: "非深户离深销户提取专题",
            desc: "如果您是非深户籍职工，已经或即将离开深圳（已离职）到其他城市就业、缴存公积金，可申请办理非深户离深销户提取业务，提取全部账户余额。",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/44444444.jpg",
            url: "http://gjj.sz.gov.cn/zdyw/fshxh/"
        },
        {
            id: 4,
            title: "公积金场景式服务专题",
            desc: "快来体验深圳市住房公积金场景式服务功能吧",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/11111.jpg",
            url: "http://gjj.sz.gov.cn/scene/"
        },
        {
            id: 5,
            title: "购买自住住房贷款",
            desc: "深圳住房公积金贷款审核全流程服务攻略在这里",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/666666.jpg",
            url: "http://gjj.sz.gov.cn/zdyw/dkqlc/"
        },
        {
            id: 6,
            title: "住房公积金贷款贷后变更",
            desc: "可由任一借款人办理，合同期限内不限制变更次数，贷款正常，无逾期贷款本息，如还款当期已办理缩期、变更还款日、变更还款方式、共同还款人对冲还贷等贷后变更业务的，不能再办理提前还款。",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/22222.jpg",
            url: "http://gjj.sz.gov.cn/zdyw/dhbg/"
        },
        {
            id: 7,
            title: "存量商品房公积金贷款",
            desc: "申请人和参与计算公积金贷款可贷额度的共同申请人,在申请当月之前在本市或异地连续按时足额缴存住房公积金满6个月，申请时公积金账户属于正常缴存状态（账户封存、冻结及销户的为非正常缴存状态）。本市和异地缴存公积金的时间可以合并计算；",
            thumb: "http://res.bchun.com/wp-content/uploads/2020/03/55555.jpg",
            url: "http://gjj.sz.gov.cn/zdyw/clspf/"
        },
    ];
    
    mounted() {
        let cityId: number = parseInt(this.$route.params.cityId);
        this.cityId = cityId;
    }

    onClick(item: any) {
        window.location.href = item.url;
    }
}
